<div [style.min-height.%]="100" class="sidebar">
  <app-logo [routerLink]="['inicio']"></app-logo>
  <app-user-cliente></app-user-cliente>
  <app-menu-cliente></app-menu-cliente>
</div>
